/**
 * PatientAdminBoardConnected — the AgentDetailViewProps-shaped wrapper around
 * PatientAdminBoard: the interactive census board rendered
 *   - inline in the main app's Home detail pane (the agent working IN the
 *     frame, same as CompatibilityBoardConnected / CarePlanBoardConnected),
 *   - full-screen in the patient-admin satellite app's Session page.
 *
 * Unlike the Care Planner/Compatibility boards, the census has no per-session state to
 * restore: it is the live ward census, a shared resource, not a conversation
 * artifact. So this wrapper takes `session` only for signature compatibility
 * with `AgentDetailViewProps` (every registered agent detail view is a
 * `ComponentType<AgentDetailViewProps>`) and renders the SAME full census
 * regardless of which patient-admin session is open — there is deliberately
 * no session-scoped filtering here. Optional so it also renders on the
 * session-less Home face (AgentFacePane) before any session exists.
 */
import type { SessionDetail } from '@/hooks/useSessions'
import { PatientAdminBoard } from './PatientAdminBoard'

interface PatientAdminBoardConnectedProps {
  session?: SessionDetail
}

export function PatientAdminBoardConnected({ session: _session }: PatientAdminBoardConnectedProps) {
  return <PatientAdminBoard />
}
